<template>
    <div class="price">
        <div class="fixed-list" :class="show ? 'fixed-list-block' : ''">
            <ul class="duibi-list">
                <li :class="curIndex === index ? 'active' : ''" v-for="(item,index) in list" :key="index" @click="toPosition(item.id,index)">{{item.label}}</li>
            </ul>
        </div>
        <div class="banner">
            <div class="banner-content">
                <div class="left">
                    <div>购买后您能立即享受到的增值服务</div>
                    <div></div>
                    <div>使用软件的完整版本/无功能限制版本（题库软件、Word、PPT批量处理软件）</div>
                    <div>得到免费题库（个人版数理化题库）</div>
                    <div>免费使用共享题库（云题库）</div>
                    <div>团队用户在线协作（云题库、网络版题库）</div>
                    <div>得到我们提供的各种咨询和培训服务</div>
                </div>
            </div>
        </div>
        <div class="wrapper">
            <div class="product-add">
                <img :src="img_syjc" alt="">
                <img :src="img_grgm" alt="">
                <img :src="img_tdgm" alt="">
                <img :src="img_kjfp" alt="">
            </div>
            <div class="top">
                <img :src="zy" alt="">
            </div>
            <!-- <div class="intro">
                <div><span>使用教程：</span>视频+语音解说，上手更快</div>
                <div><span>个人购买：</span>我们会定期安排在线直播培训（详见直播安排）</div>
                <div><span>团队购买（30+）：</span>我们会安排一对一专职客服统一远程培训和解答遇到的疑问</div>
                <div>
                    <div>如需开发票，请提供如下信息</div>
                    <div>1、发票抬头名称(必须)</div>
                    <div>2、纳税人识别号(必须)</div>
                </div>
            </div> -->
            <div v-show="turnIndex === 0" class="same net">
                <div class="title">乐分享题库系统：<strong>价目表</strong></div>
                <div class="update">
                    <img :src="icon_tishi" alt="">
                    <div>基础费用视不同情况可以减免。</div>
                </div>
                <!-- <div class="download"><img :src="icon_xiazai" alt=""><span><a :href="path + './soft/LFX_ExercLib_Net_Test.rar'">下载试用</a></span></div> -->
            </div>
            <div v-show="turnIndex === 1" class="same net">
                <div class="title">乐分享题库系统：<strong>网络客户端版</strong></div>
                <div class="update">
                    <img :src="icon_tishi" alt="">
                    <div>1、购买后安装到自己的服务器上， 完全自主管理。</div>
                    <div>2、一次性付费</div>
                    <div>3、按年收取费用（可选）</div>
                </div>
                <div class="download"><img :src="icon_xiazai" alt=""><span><a :href="path + './soft/LFX_ExercLib_Net_Test.rar'">下载试用</a></span></div>
            </div>
            <div v-show="turnIndex === 2" class="same cloud">
                <div class="title">乐分享题库系统：<strong>云题库</strong></div>
                <div class="update">
                    <img :src="icon_tishi" alt="">
                    <div>1、在线使用</div>
                    <div>2、凭账号和密码在任意电脑登陆使用</div>
                    <div>3、按年付费</div>
                </div>
                <div class="download">云题库：
                    <img :src="icon_xiazai" alt=""><span @click="toWeb">网页版</span>
                    <img :src="icon_xiazai" alt=""><span><a :href="path + './soft/LFX_ExercLib_Net_Test.rar'">客户端版</a></span>
                    <img :src="icon_xiazai" alt=""><span @click="toExam">在线考试</span>
                    <img :src="icon_xiazai" alt=""><div class="wx_code">微信小程序<span></span></div>
                </div>
            </div>
            <div v-show="turnIndex === 3" class="same personal">
                <div class="title">乐分享题库系统：<strong>个人版</strong></div>
                <div class="update">
                    <img :src="icon_tishi" alt="">
                    <div>1、购买后安装到自己的一台或者多台（U盘版）电脑上</div>
                    <div>2、一次性付费</div>
                    <div>3、免费升级</div>
                </div>
                <div class="download"><img :src="icon_xiazai" alt=""><span><a href="http://www.001help.com/soft/LFX_ExercLib__Personal.rar">下载试用</a></span></div>
            </div>
            <div v-show="turnIndex === 4" class="same personal">
                <div class="title">乐分享题库系统个人版、网络客户端版、云题库功能对比</div>
            </div>
            <div class="turn">
                <div class="one" @click="turn(0,'duibi')" :class="turnIndex === 0 ? 'active' : ''">
                    <!-- <span>1</span> -->
                    <span><strong>题库软件</strong> 价格一览</span>
                    <div class="line"></div>
                </div>
                
                <span style="font-size:18px;"><strong><img :src="icon_tishi" alt="">专业 <img :src="icon_tishi" alt="">优质 <img :src="icon_tishi" alt="">高性价比  <img :src="icon_tishi" alt="">完全兼容WPS和Word  <img :src="icon_tishi" alt="">大量题目极速一键批量入库</strong> </span>
                <!-- <div class="two" @click="turn(1,'net')" :class="turnIndex === 1 ? 'active' : ''">
                    <span>1</span>
                    <span>网络客户端版</span>
                    <div class="line"></div>
                </div>
                <div class="three" @click="turn(2,'cloud')" :class="turnIndex === 2 ? 'active' : ''">
                    <span>2</span>
                    <span>云题库</span>
                    <div class="line"></div>
                </div>
                <div class="four" @click="turn(3,'personal')" :class="turnIndex === 3 ? 'active' : ''">
                    <span>3</span>
                    <span>个人版</span>
                    <div class="line"></div>
                </div>
                <div class="five" @click="turn(4,'duibi')" :class="turnIndex === 4 ? 'active' : ''">
                    <span>4</span>
                    <span>版本对比</span>
                    <div class="line"></div>
                </div> -->
            </div>
            <!-- 乐分享题库系统个人版、网络版、云题库功能对比 -->
            <div v-show="turnIndex === 0"  id="duibi" style="padding-top:20px"></div>
            
            <ul v-show="turnIndex === 0"  class="duibi-list" id="duibi-list">
                <li :class="curIndex === index ? 'active' : ''" v-for="(item,index) in list" :key="index" @click="toPosition(item.id,index)">{{item.label}}</li>
            </ul>
            <div v-show="turnIndex === 0"  class="same duibi" id="duibi">
                <div class="list">
                    <div class="duibiheader-fixed" :class="show ? 'duibiheader-block' : ''">
                        <ul class="common">
                            <li><strong>主要功能</strong></li>
                            <li style="line-height:75px"><strong>详细功能</strong></li>
                            <!-- <li style="line-height:53px">描述</li> -->
                            <li>
                                <div style="border-bottom:1px solid #EBEEF5">乐分享题库系统</div>
                                <ul>
                                    <li style="padding:0">个人版</li>
                                    <li style="padding:0">网络版</li>
                                    <li style="padding:0">网页版</li>
                                    <li style="padding:0">云题库</li>
                                </ul>
                            </li>
                        </ul>
                        
                        <ul class="common">
                            <li>软件价格</li>
                            <li>按购买的用户数计费，费用极低！</li>
                            <li>
                                <ul>
                                    <li style="padding:0;padding-left:10px;line-height:1.5;">单机版<span style="font-size:16px;"><sup>¥</sup></span><span style="font-size:26px;font-weight:bold">198</span>元/套<br>U盘版<span style="font-size:16px;"><sup>¥</sup></span><span style="font-size:26px;font-weight:bold">298</span>元/套</li>
                                    <li style="padding:0;padding-left:10px;line-height:1.5;"><span style="font-size:16px;"><sup>¥</sup></span><span style="font-size:26px;font-weight:bold">198</span>元/用户<br>（5用户起售）</li>
                                    <li style="padding:0;padding-left:10px;line-height:1.5;"><span style="font-size:16px;"><sup>¥</sup></span><span style="font-size:26px;font-weight:bold">99</span>元/用户<br>（5用户起售）</li>
                                    <li style="padding:0;padding-left:10px;line-height:1.5;"><span style="font-size:16px;"><sup>¥</sup></span><span style="font-size:26px;font-weight:bold">268</span>元/用户/年</li>
                                </ul>
                            </li>
                        </ul>
                        <ul class="common">
                            <li style="line-height:62px">基础科目数</li>
                            <li style="line-height:62px">赠送的科目数量</li>
                            <li>
                                <!-- <ul>
                                    <li style="line-height:62px">赠送的科目数量</li>
                                </ul> -->
                                <ul>
                                    <li>
                                        <ul>
                                            <li style="text-align:left;padding:0;padding-left:10px;line-height:2;">1、个人版不限科目数量；<br>2、网络版、网页版、云题库默认赠送科目数量为：1~50用户，包含5个科目；100用户及以上，每增加100用户数增加科目数量10个科目数；1000用户数量以上，不限科目数量</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <ul class="common">
                            <li>基础费用</li>
                            <li style="text-align:left;padding:0;line-height:2;">1、包含：首次远程安装、配置及一年售后服务<br>2、一次性购买用户数超出100人，本基础费用减免</li>
                            <li>
                                <ul>
                                    <li style="padding:0;"><span style="font-size:14px;"><sup></sup></span><span style="font-size:16px;font-weight:bold"></span>自由下载安装</li>
                                    <li style="padding:0;"><span style="font-size:14px;"><sup>¥</sup></span><span style="font-size:16px;font-weight:bold">3000元</span>首次部署</li>
                                    <li style="padding:0;"><span style="font-size:14px;"><sup>¥</sup></span><span style="font-size:16px;font-weight:bold">3000元</span>首次部署</li>
                                    <li style="padding:0;"><span style="font-size:14px;"><sup>¥</sup></span><span style="font-size:16px;font-weight:bold">300元</span>首次部署</li>
                                </ul>
                            </li>
                        </ul>
                        <ul class="common">
                        <li>联系方式</li>
                        <li>QQ 710726095</li>
                        <!-- <li></li> -->
                        <li>电话（微信同号）：17751736908</li>
                    </ul>
                    </div>
                    <ul class="common">
                        <li><strong>主要功能</strong></li>
                        <li style="line-height:75px"><strong>详细功能</strong></li>
                        <!-- <li style="line-height:53px">描述</li> -->
                        <li>
                            <div style="border-bottom:1px solid #EBEEF5"><strong>乐分享题库系统</strong></div>
                            <ul>
                                <li style="padding:0"><strong>个人版</strong></li>
                                <li style="padding:0"><strong>网络版</strong></li>
                                <li style="padding:0"><strong>网页版</strong></li>
                                <li style="padding:0"><strong>云题库</strong></li>
                            </ul>
                        </li>
                    </ul>
                    
                        <ul class="common">
                            <li>软件价格</li>
                            <li>按购买的用户数计费，费用极低！</li>
                            <li>
                                <ul>
                                    <li style="padding:0;padding-left:10px;line-height:1.5;">单机版<span style="font-size:16px;"><sup>¥</sup></span><span style="font-size:26px;font-weight:bold">198</span>元/套<br>U盘版<span style="font-size:16px;"><sup>¥</sup></span><span style="font-size:26px;font-weight:bold">298</span>元/套</li>
                                    <li style="padding:0;padding-left:10px;line-height:1.5;"><span style="font-size:16px;"><sup>¥</sup></span><span style="font-size:26px;font-weight:bold">198</span>元/用户<br>（5用户起售）</li>
                                    <li style="padding:0;padding-left:10px;line-height:1.5;"><span style="font-size:16px;"><sup>¥</sup></span><span style="font-size:26px;font-weight:bold">99</span>元/用户<br>（5用户起售）</li>
                                    <li style="padding:0;padding-left:10px;line-height:1.5;"><span style="font-size:16px;"><sup>¥</sup></span><span style="font-size:26px;font-weight:bold">268</span>元/用户/年</li>
                                </ul>
                            </li>
                        </ul>
                        <ul class="common">
                            <li style="line-height:62px">基础科目数</li>
                            <li style="line-height:62px">赠送的科目数量</li>
                            <li>
                                <!-- <ul>
                                    <li style="line-height:62px">赠送的科目数量</li>
                                </ul> -->
                                <ul>
                                    <li>
                                        <ul>
                                            <li style="text-align:left;padding:0;padding-left:10px;line-height:2;">1、个人版不限科目数量；<br>2、网络版、网页版、云题库默认赠送科目数量为：1~50用户，包含5个科目；100用户及以上，每增加100用户数增加科目数量10个科目数；1000用户数量以上，不限科目数量</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <ul class="common">
                            <li>基础费用</li>
                            <li style="text-align:left;padding:0;line-height:2;">1、包含：首次远程安装、配置及一年售后服务<br>2、一次性购买用户数超出100人，本基础费用减免</li>
                            <li>
                                <ul>
                                    <li style="padding:0;"><span style="font-size:14px;"><sup>¥</sup></span><span style="font-size:16px;font-weight:bold">0</span>首次部署</li>
                                    <li style="padding:0;"><span style="font-size:14px;"><sup>¥</sup></span><span style="font-size:16px;font-weight:bold">3000</span>首次部署</li>
                                    <li style="padding:0;"><span style="font-size:14px;"><sup>¥</sup></span><span style="font-size:16px;font-weight:bold">3000</span>首次部署</li>
                                    <li style="padding:0;"><span style="font-size:14px;"><sup>¥</sup></span><span style="font-size:16px;font-weight:bold">300</span>首次部署</li>
                                </ul>
                            </li>
                        </ul>
                    <ul class="common" id="cooperation">
                        <li style="line-height:62px"><strong>多人协作</strong></li>
                        <li>
                            <div>实时共享协作</div>
                            <!-- <div class="kong"></div> -->
                            <!-- <div>异步协作</div> -->
                        </li>
                        <!-- <li>
                            <div>实时同步数据，快速，效率高；由管理员分配不同的任务和权限</div>
                            <div>通过导入导出方式实现多人协作</div>
                        </li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <!-- <div class="kong"></div> -->
                            <!-- <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                            </ul> -->
                        </li>
                    </ul>
                    <!-- <ul class="common" id="wrong">
                        <li>错题集</li>
                        <li>快速添加整理错题</li>
                        
                        <li>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul> -->
                    <ul class="common" id="handout">
                        <li>讲义、备课</li>
                        <li>快速生成讲义、备课</li>
                        <!-- <li>
                            <div>1、可以按知识点组织，也可以自定义组织形式，直接用于上课。</div>
                            <div>2、可以编辑、修改、克隆拓展</div>
                        </li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="catalog">
                        <li>知识库目录<br>（章节、知识点、试卷库）</li>
                        <li>
                            <div>目录管理</div>
                            <div>鼠标拖动即时调整</div>
                            <div>目录层级无限制</div>
                            <div>批量导入目录</div>
                            <div>全局共享</div>
                            <div>机构私有</div>
                            <div>用户私有</div>
                        </li>
                        <!-- <li>
                            <div>允许完全自定义，增删查改</div>
                            <div>鼠标拖动即可调整目录位置、上下级层次</div>
                            <div>题目随目录的调整相应自动调整</div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>可选，机构或者用户自行设定</div>
                            <div>机构用户可自行设定</div>
                            <div>用户可以自行设定</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 3" :key="item + 'a'">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="type">
                        <li>题型</li>
                        <li>
                            <div>支持单选、多选、判断等所有基本题型</div>
                            <div>选择题选项数可调（支持3~8个选项）</div>
                            <div>选择题支持单独调整某个题目的选项数</div>
                            <div>支持自定义题型</div>
                            <div>完全支持复合题（组合题）</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>支持所有基本题型自由组合形成的新题型!!!</div>
                            <div class="kong"></div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>
                            <div id="difficulty">难度</div>
                            <div id="scope">适用范围</div>
                            <div id="label">题类标签</div>
                        </li>
                        <li>
                            <div>支持指定难度系数</div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                        </li>
                        <!-- <li>
                            <div>完全允许自定义可以增删查改</div>
                            <div>完全允许自定义可以增删查改</div>
                            <div>完全允许自定义可以增删查改</div>
                        </li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 2" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="entry">
                        <li>题目录入</li>
                        <li>
                            <div>全兼容Word</div>
                            <div>全兼容WPS</div>
                            <div>支持图形、图片、表格</div>
                            <div>支持MathType公式编辑器</div>
                            <!-- <div>支持视频上传</div>
                            <div>支持音频上传</div> -->
                            <div>单题录入</div>
                            <div>批量上传</div>
                            <div>专业编辑器</div>
                            <div>excel格式</div>
                            <div>模板1</div>
                            <div>模板2</div>
                            <div>模板3</div>
                            <div>重题检查</div>
                            <div>批量入库</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>1、自动识别题型、题目、答案、解析、适用范围、来源、分值等</div>
                            <div>2、一键智能处理：多个功能一键处理，省时省力（熟练用户强烈推荐！）</div>
                            <div>快速，不依赖Word和WPS，上手更快速</div>
                            <div>特别适合专业人士、出版社编辑、专业录题编辑</div>
                            <div>确保公式、图形等入库后再次生成试卷时仍然原样可以编辑</div>
                            <div>软件中嵌入Word，直接使用Word添加、编辑题目</div>
                            <div>从Excel模板中批量导入题目</div>
                            <div>
                                1、多个上传模板，几乎适应所有试卷样式<br>
                                2、提供大量快速批量处理工具<br>
                                3、熟练用户最快1小时可上传2000~3000题
                            </div>
                            <div>重题检查，显示每个题目的疑似重题，易于筛查</div>
                            <div>自动检查试卷是否符合入库标准，提示准确，入库快速，入库内容自动分类</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 2" :key="item + 'a'">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <!-- <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul> -->
                            <ul v-for="item in 3" :key="item + 'd'">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="management">
                        <li>试题管理</li>
                        <li>
                            <div>题目属性标记于每一题上方</div>
                            <div>编辑</div>
                            <div>删除</div>
                            <div>审核控制</div>
                            <div>批量修改属性</div>
                            <div>拖动题目更改目录</div>
                            <div>收藏</div>
                            <div>纠错</div>
                            <div>全局共享</div>
                            <div>机构私有</div>
                            <div>用户私有</div>
                        </li>
                        <!-- <li>
                            <div>显示题目所属章节、知识点、题型、难度等</div>
                            <div>编辑和修改题目内容</div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>批量快速调整章节、知识点、题型、难度、来源、分值等</div>
                            <div>支持批量拖动题目即可以修改目录所属章节、知识点</div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>可选，机构或者用户自行设定</div>
                            <div>机构用户可自行设定</div>
                            <div>用户可以自行设定</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="retrieval">
                        <li>试题检索</li>
                        <li>
                            <div>快速搜索</div>
                            <div>快速筛选</div>
                            <div>快速排序</div>
                        </li>
                        <!-- <li>
                            <div>章节、知识点、题目内容、使用时间、使用次数、来源、回收站、……，任意组合条件搜索</div>
                            <div>章节、知识点、题型、难度、有无答案、有无解析、收藏夹、……，任意组合条件筛选</div>
                            <div>题型、难度、组卷次数、题目内容、……，任意组合条件排序</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="manual">
                        <li>手工组卷</li>
                        <li>
                            <div>查看题目解析</div>
                            <div>试题篮管理</div>
                            <div>重题检查</div>
                            <!-- <div>错题集选题</div> -->
                            <div>试卷中选题</div>
                            <div>收藏夹选题</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>显示相似题内容，快速准确判定是否为重题</div>
                            <div>从错题集选题</div>
                            <div>从指定的试卷中选题</div>
                            <div>从收藏夹选题</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <!-- <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul> -->
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="intelligent">
                        <li>智能组卷</li>
                        <li>
                            <div>全新选题</div>
                            <div>追加选题</div>
                            <div>组卷方案</div>
                        </li>
                        <!-- <li>
                            <div>新出一份试卷</div>
                            <div>在原有内容基础上追加题目</div>
                            <div>把选题条件保存为组卷方案，后续随时调用生成新试卷</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="preview">
                        <li>试卷预览</li>
                        <li>
                            <div>调整题目位置</div>
                            <div>换一题</div>
                            <div>分数设置</div>
                            <div>试卷样式设置</div>
                            <div>保存试卷</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>自定义试卷样式</div>
                            <div>自定义卷头：标题、密封线、誊分栏等</div>
                            <div class="kong"></div>
                        </li> -->
                        <li>
                            <ul v-for="item in 5" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="library">
                        <li>试卷库</li>
                        <li>
                            <div>试卷管理</div>
                            <div>查看试卷内容</div>
                            <div>发布考试</div>
                            <div>生成试卷（Word格式）</div>
                            <div>生成试卷（PDF格式）</div>
                            <div>生成PPT</div>
                            <!-- <div>生成电子书</div> -->
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>1、速度快、自动排版</div>
                            <div>2、选择题选项、括号自动对齐</div>
                            <div>3、多种内置试卷样式快速切换</div>
                            <div>4、教师卷、普通卷、学生卷任选</div>
                            <div>5、选择题答案以表格方式展示（可选）</div>
                            <div>6、多个内置版式一键切换</div>
                            <div>方便传阅，保护内容</div>
                            <div>生成PPT幻灯片，默认切换效果</div>
                            <div class="kong"></div>
                        </li> -->
                        <li>
                            <ul v-for="item in 4" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <!-- <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul> -->
                        </li>
                    </ul>
                    <ul class="common">
                        <li>
                            <div id="department">部门管理</div>
                            <div id="subject">学科</div>
                            <div id="teaching">教材</div>
                            <div id="version">教材版本</div>
                            <div id="section">学段</div>
                            <div id="grade">年级</div>
                            <div id="personnel">人员管理</div>
                        </li>
                        <li>
                            <div>增加、删除、调整、搜索</div>
                            <div>增加、删除、调整、搜索</div>
                            <div>增加、删除、调整、搜索</div>
                            <div>增加、删除、调整、搜索</div>
                            <div>增加、删除、调整、搜索</div>
                            <div>增加、删除、调整、搜索</div>
                            <div>增加、删除、调整、搜索</div>
                        </li>
                        <!-- <li>
                            
                        </li> -->
                        <li>
                            <ul v-for="item in 6" :key="item">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="role">
                        <li>角色与权限管理</li>
                        <li>
                            <div>允许设定任意多个用户组</div>
                            <div>不同用户组分配不同权限</div>
                            <div>不同用户批量分配不同角色和权限</div>
                            <div>支持跨部门权限设置</div>
                        </li>
                        <!-- <li>
                            
                        </li> -->
                        <li>
                            <ul v-for="item in 4" :key="item">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="online">
                        <li>在线考试</li>
                        <!-- <li><div class="row2">发布考试</div></li> -->
                        <li>
                            <div>支持电脑、手机、微信小程序在线答题</div>
                            <div>单机版在线答题</div>
                        </li>
                        <li>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="special">
                        <li>特色服务</li>
                        <li>
                            <div>试卷自动加版权水印</div>
                            <div>logo和形象页定制</div>
                            <div>特殊定制需求</div>
                            <div>二次开发接口</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>付费定制</div>
                            <div>付费定制</div>
                        </li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="after">
                        <li>售后服务</li>
                        <li>
                            <div>电话、QQ咨询</div>
                            <div>一对一专业客服对接</div>
                            <div>远程安装</div>
                            <div>远程培训</div>
                            <div>有限上门服务支持</div>
                            <div>1年免费技术支持</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>详询客服。徐州市区可增加免费上门服务1次（限标准型及更高类型）</div>
                        </li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-error"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>欢迎咨询</li>
                        <li>元/套（含税）</li>
                        <!-- <li></li> -->
                        <li>欢迎咨询-QQ710726095</li>
                    </ul>
                    <ul class="common">
                        <li>备注</li>
                        <li></li>
                        <li>网络版和web平台视具体细分版本有所区别，请参考相关版本详细说明</li>
                    </ul>
                    <ul class="common">
                        <li style="text-align:left;text-indent:10px">
                            <div>说明：</div>
                            <div><i class="el-icon-success"></i> 表示支持</div>
                            <div><i class="el-icon-error"></i> 表示不支持</div>
                        </li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
            </div>
            
            <!-- 乐分享题库系统  云题库 -->
            <div v-show="turnIndex === 1" id="cloud" style="padding-top:20px"></div>
            <div v-show="turnIndex === 1" class="same cloud">
                <div class="list">
                    <div class="cloud-header" :class="cloudShow ? 'header-fixed' : ''">
                        <ul class="common">
                            <li>主要功能</li>
                            <li style="line-height:75px">详细功能</li>
                            <!-- <li style="line-height:65px">描述</li> -->
                            <li>
                                <div style="border-bottom:1px solid #EBEEF5">乐分享题库  云题库</div>
                                <ul style="font-size:14px">
                                    <li>个人免费</li>
                                    <li>个人VIP</li>
                                    <li>考试型</li>
                                    <li style="font-size:12px">团队协作型</li>
                                    <li style="font-size:12px">自主管理型</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <ul class="common" id="cloud-header">
                        <li>主要功能</li>
                        <li style="line-height:75px">详细功能</li>
                        <!-- <li style="line-height:65px">描述</li> -->
                        <li>
                            <div style="border-bottom:1px solid #EBEEF5">乐分享题库  云题库</div>
                            <ul style="font-size:14px">
                                <li>个人免费</li>
                                <li>个人VIP</li>
                                <li>考试型</li>
                                <li style="font-size:12px">团队协作型</li>
                                <li style="font-size:12px">自主管理型</li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>价格</li>
                        <li style="line-height:31px">元/年/人/学科（含税）</li>
                        <!-- <li></li> -->
                        <li>
                            <ul style="font-size:12px;">
                                <!-- <li style="line-height:31px">0元</li>
                                <li style="line-height:31px" >260元/年</li>
                                <li style="line-height:31px;text-indent: -14px;" >480元/年/人/学科</li>
                                <li style="line-height:31px">1~6人 ￥1580，6人起售，每超出1人增加198元</li>
                                <li style="line-height:31px">1~100人 ￥26800，100人起售，每超出1人增加228元</li> -->
                                <li style="line-height:31px">欢迎咨询-18652255099</li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>私有题库</li>
                        <li>仅自己可以查看和编辑的题库</li>
                        <!-- <li></li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>用户权限分配和管理</li>
                        <li>管理员权限</li>
                        <!-- <li>管理员可以给用户分配不同权限，如：上传、审核、下载、修改等</li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>版权核查</li>
                        <li>防止侵权</li>
                        <!-- <li>人机结合对题目及信息进行审核，防止侵权，避免版权纠纷</li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>共享收益分成</li>
                        <li>分享题目到全局，有下载可以获得收益</li>
                        <!-- <li>收益按月结算</li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-error"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>客户端</li>
                        <li>客户端上传和管理维护</li>
                        <!-- <li>客户端更方便、快速</li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>web端</li>
                        <li>web端上传和管理维护</li>
                        <!-- <li>web端可以直接在浏览器中操作，无需安装软件</li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>在线考试</li>
                        <li>可以发布考试</li>
                        <!-- <li>支持电脑、手机、微信小程序在线答题，详细功能见在线考试功能介绍</li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>考试端考生人数</li>
                        <li>默认可用考生数</li>
                        <!-- <li>每增加一个考生按10元/年/人收费</li> -->
                        <li>
                            <ul>
                                <li style="padding:0;font-size:20px;color:red">0</li>
                                <li style="padding:0;font-size:20px;color:red">1</li>
                                <li style="padding:0;font-size:20px;color:blue">100</li>
                                <li style="padding:0;font-size:20px;color:blue">300</li>
                                <li style="padding:0;font-size:20px;color:blue">3000</li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>独立云空间</li>
                        <li>
                            <div>独立云空间</div>
                            <div>免费维护管理</div>
                        </li>
                        <!-- <li>
                            1、专业人员维护
                            2、性价比高
                            3、私密性、安全性更高
                        </li> -->
                        <li>
                            <ul v-for="item in 2" :key="item">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>多人协作</li>
                        <li>实时同步数据</li>
                        <!-- <li>团队或者学校、公司内部可以多人协作，快速建立和维护高质量题库</li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>错题集</li>
                        <li>快速添加整理错题</li>
                        <!-- <li></li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>讲义、备课</li>
                        <li>快速生成讲义、备课</li>
                        <!-- <li>
                            <div>1、可以按知识点组织，也可以自定义组织形式，直接用于上课。</div>
                            <div>2、可以编辑、修改、克隆拓展</div>
                        </li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li style="padding-top:100px">知识库目录<br>（章节、知识点、试卷库）</li>
                        <li>
                            <div>目录管理</div>
                            <div>鼠标拖动即时调整</div>
                            <div>目录层级无限制</div>
                            <div>批量导入目录</div>
                            <div>全局共享</div>
                            <div>机构私有</div>
                            <div>用户私有</div>
                        </li>
                        <!-- <li>
                            <div>允许完全自定义，增删查改</div>
                            <div>鼠标拖动即可调整目录位置、上下级层次</div>
                            <div>题目随目录的调整相应自动调整</div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>可选，机构或者用户自行设定</div>
                            <div>机构用户可自行设定</div>
                            <div>用户可以自行设定</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                             <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 3" :key="item + 'a'">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>题型</li>
                        <li>
                            <div>支持单选、多选、判断、填空、问答等所有基本题型</div>
                            <div>选择题选项数可调（支持3~8个选项）</div>
                            <div>选择题支持单独调整某个题目的选项数</div>
                            <div>支持自定义题型</div>
                            <div>完全支持复合题（组合题）</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>支持所有基本题型自由组合形成的新题型！！！</div>
                        </li> -->
                        <li>
                             <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>
                            <div>难度</div>
                            <div>适用范围</div>
                            <div>题类标签</div>
                        </li>
                        <li>
                            <div>支持指定难度系数</div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                        </li>
                        <!-- <li>
                            <div>完全允许自定义,可以增删查改</div>
                            <div>完全允许自定义,可以增删查改</div>
                            <div>完全允许自定义,可以增删查改</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>题目录入</li>
                        <li>
                            <div>全兼容Word</div>
                            <div>支持图形、图片、表格</div>
                            <div>支持MathType公式编辑器</div>
                            <div>支持视频上传</div>
                            <div>支持音频上传</div>
                            <div>单题录入</div>
                            <div>批量上传</div>
                            <div>专业编辑器</div>
                            <div>Word全兼容（推荐）</div>
                            <div>excel格式</div>
                            <div>模板1</div>
                            <div>模板2</div>
                            <div>模板3</div>
                            <div>重题检查</div>
                            <div>批量入库</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>1、自动识别题型、题目、答案、解析、适用范围、来源、分值等</div>
                            <div>2、一键智能处理：多个功能一键处理，省时省力（熟练用户强烈推荐！）</div>
                            <div>快速，不依赖Word和WPS，上手更快速</div>
                            <div>特别适合专业人士、出版社编辑、专业录题编辑</div>
                            <div>确保公式、图形等入库后再次生成试卷时仍然原样可以编辑</div>
                            <div>软件中嵌入Word，直接使用Word添加、编辑题目</div>
                            <div>从Excel模板中批量导入题目</div>
                            <div>
                                1、多个上传模板，几乎适应目前所有试卷样式<br>
                                2、提供大量快速批量处理工具<br>
                                3、熟练用户最快1小时可以上传2000~3000题
                            </div>
                            <div>重题检查，显示每个题目的疑似重题，易于筛查</div>
                            <div>自动检查试卷是否符合入库标准，提示准确，入库快速，入库内容自动分类</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 2" :key="item + 'a'">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 2" :key="item + 'b'">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 3" :key="item + 'd'">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>试题管理</li>
                        <li>
                            <div>题目属性标记于每一题上方</div>
                            <div>编辑和修改题目内容</div>
                            <div>删除</div>
                            <div>审核控制</div>
                            <div>批量修改属性</div>
                            <div>拖动题目更改目录</div>
                            <div>收藏</div>
                            <div>纠错</div>
                            <div>全局共享</div>
                            <div>机构私有</div>
                            <div>用户私有</div>
                        </li>
                        <!-- <li>
                            <div>显示题目所属章节、知识点、题型、难度等</div>
                            <div>仅限本人上传的题目</div>
                            <div>仅限本人有审核权限的题目</div>
                            <div>仅限本人上传的题目</div>
                            <div>仅限本人有审核权限的题目</div>
                            <div class="kong"></div>
                            <div>批量快速调整章节、知识点、题型、难度、来源、分值等</div>
                            <div>支持批量拖动题目即可以修改目录所属章节、知识点</div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>可选，机构或者用户自行设定</div>
                            <div>机构用户可自行设定</div>
                            <div>用户可以自行设定</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 2" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 2" :key="item + 'a'">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 3" :key="item + 'c'">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 2" :key="item + 'b'">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>试题检索</li>
                        <li>
                            <div>快速搜索</div>
                            
                            
                            <div>快速筛选</div>
                            
                            <div>快速排序</div>
                        </li>
                        <!-- <li>
                            <div>章节、知识点、题目内容、使用时间、使用次数、来源、回收站、……，任意组合条件搜索</div>
                            <div>章节、知识点、题型、难度、有无答案、有无解析、收藏夹、……，任意组合条件筛选</div>
                            <div>题型、难度、组卷次数、题目内容、……，任意组合条件排序</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li style="line-height: 186px">手工组卷</li>
                        <li>
                            <div>查看题目解析</div>
                            <div>试题篮管理</div>
                            <div>重题检查</div>
                            <div>错题集选题</div>
                            <div>试卷中选题</div>
                            <div>收藏夹选题</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>显示相似题内容，快速准确判定是否为重题</div>
                            <div>从错题集选题</div>
                            <div>从指定的试卷中选题</div>
                            <div>从收藏夹选题</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 2" :key="item + 'a'">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li style="line-height:124px">智能组卷</li>
                        <li>
                            <div>全新选题</div>
                            <div>追加选题</div>
                            <div>组卷方案</div>
                        </li>
                        <!-- <li>
                            <div>新出一份试卷</div>
                            <div>在原有内容基础上追加题目</div>
                            <div>把选题条件保存为组卷方案，后续随时调用生成新试卷</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li style="line-height: 186px">试卷预览</li>
                        <li>
                            <div>仅限自己的试卷</div>
                            <div>调整题目位置</div>
                            <div>换一题</div>
                            <div>分数设置</div>
                            <div>试卷样式设置</div>
                            <div>保存试卷</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>自定义试卷样式</div>
                            <div>自定义卷头：标题、密封线、誊分栏等</div>
                            <div class="kong"></div>
                        </li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                            </ul>
                            <ul v-for="item in 5" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>试卷库</li>
                        <li>
                            <div>试卷管理</div>
                            <div>查看试卷内容</div>
                            <div>发布考试</div>
                            <div>生成试卷（Word格式）</div>
                            <div>生成试卷（PDF格式）</div>
                            <div>生成PPT</div>
                            <div>生成电子书</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>1、速度快、自动排版</div>
                            <div>2、选择题选项、括号自动对齐</div>
                            <div>3、多种内置试卷样式快速切换</div>
                            <div>4、教师卷、普通卷、学生卷任选</div>
                            <div>5、选择题答案以表格方式展示（可选）</div>
                            <div>6、多个内置版式一键切换</div>
                            <div>方便传阅，保护内容</div>
                            <div>生成PPT幻灯片，默认切换效果</div>
                            <div class="kong"></div>
                        </li> -->
                        <li>
                            <ul v-for="item in 2" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 3" :key="item + 'a'">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>
                            <div>部门管理</div>
                            <div>学科</div>
                            <div>教材</div>
                            <div>教材版本</div>
                            <div>学段</div>
                            <div>年级</div>
                            <div>人员管理</div>
                        </li>
                        <li>
                            <div>增加、删除、调整、搜索</div>
                            <div>增加、删除、调整、搜索</div>
                            <div>增加、删除、调整、搜索</div>
                            <div>增加、删除、调整、搜索</div>
                            <div>增加、删除、调整、搜索</div>
                            <div>增加、删除、调整、搜索</div>
                            <div>增加、删除、调整、搜索</div>
                        </li>
                        <!-- <li>
                            
                        </li> -->
                        <li>
                            <ul v-for="item in 2" :key="item">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 2" :key="item + 'a'">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 2" :key="item + 'b'">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li style="line-height:124px">角色与权限管理</li>
                        <li>
                            <div>允许设定任意多个用户组</div>
                            <div>不同用户组分配不同权限</div>
                            <div>不同用户批量分配不同角色和权限</div>
                            <div>支持跨部门权限设置</div>
                        </li>
                        <!-- <li>
                            
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li style="line-height:93px">运行环境</li>
                        <li>
                            <div>客户端</div>
                            <div>web端</div>
                            <div>网络要求</div>
                        </li>
                        <!-- <li></li> -->
                        <li>
                            <ul>
                                <li>Windows Xp/Vista/7/8/10</li>
                            </ul>
                            <ul>
                                <li>谷歌、Edge、火狐、腾讯、360极速任意一个浏览器皆可</li>
                            </ul>
                            <ul>
                                <li>互联网</li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>特色服务</li>
                        <li>
                            <div>试卷自动加版权水印</div>
                            <div>logo和web首页UI定制</div>
                            <div>特殊定制需求</div>
                            <div>二次开发接口</div>
                        </li>
                        <!-- <li>
                            <div>50人以上</div>
                            <div>付费定制</div>
                            <div>付费定制</div>
                            <div>付费定制</div>
                        </li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="cloud-shouhou">
                        <li>售后服务</li>
                        <li>
                            <div>电话、QQ咨询</div>
                            <div>一对一专业客服对接</div>
                            <div>远程培训</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div>50人以上</div>
                            <div>50人以上</div>
                        </li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                            <ul v-for="item in 2" :key="item">
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-error"></i></li>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>

                    <ul class="common">
                        <li style="text-align:left;text-indent:10px">
                            <div>说明：</div>
                            <div><i class="el-icon-success"></i> 表示支持</div>
                            <div><i class="el-icon-error"></i> 表示不支持</div>
                        </li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
            </div>
            <!-- 乐分享题库系统  个人通用版 -->
            <div v-show="turnIndex === 2" id="personal" style="padding-top:20px"></div>
            <div v-show="turnIndex === 2" class="same personal">
                <!-- <div class="title">乐分享题库系统  个人通用版  产品参数</div>
                <div class="update">
                    <div>1、购买后安装到自己的一台或者多台（U盘版）电脑上</div>
                    <div>2、一次性付费</div>
                    <div>3、免费升级</div>
                </div> -->
                <div class="list">
                    <div class="personal-header" :class="personalShow ? 'header-fixed' : ''">
                        <ul class="common">
                            <li>主要功能</li>
                            <li style="line-height:75px">详细功能</li>
                            <!-- <li style="line-height:53px">描述</li> -->
                            <li>
                                <div style="border-bottom:1px solid #EBEEF5">乐分享题库 个人版</div>
                                <ul>
                                    <li>单机版</li>
                                    <li>U盘版</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <ul class="common" id="personal-header">
                        <li>主要功能</li>
                        <li style="line-height:75px">详细功能</li>
                        <!-- <li style="line-height:53px">描述</li> -->
                        <li>
                            <div style="border-bottom:1px solid #EBEEF5">乐分享题库 个人版</div>
                            <ul>
                                <li>单机版</li>
                                <li>U盘版</li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>价格</li>
                        <li></li>
                        <!-- <li></li> -->
                        <li>
                            <ul>
                                <li>欢迎咨询-18652255099</li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>收费方式</li>
                        <li></li>
                        <!-- <li></li> -->
                        <li style="color: blue">一次性收费</li>
                    </ul>
                    <ul class="common">
                        <li>后续升级</li>
                        <li></li>
                        <!-- <li></li> -->
                        <li style="color: blue">免费升级</li>
                    </ul>
                    <ul class="common">
                        <li>电脑损坏丢失</li>
                        <li></li>
                        <!-- <li></li> -->
                        <li style="color: blue">免费更换授权</li>
                    </ul>
                    <ul class="common">
                        <li>U盘损坏丢失</li>
                        <li></li>
                        <!-- <li></li> -->
                        <li style="color: blue">免费更换授权</li>
                    </ul>
                    <ul class="common">
                        <li>有效期限</li>
                        <li style="color: red;">一次购买，永久使用</li>
                        <!-- <li></li> -->
                        <li style="color: red;">永久</li>
                    </ul>
                    <ul class="common">
                        <li>多人协作</li>
                        <li>通过导出和导入功能实现共享协作</li>
                        <!-- <li>团队或者学校、公司内部可以多人协作，快速建立和维护高质量题库</li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>知识库目录<br>（章节、知识点、试卷库）</li>
                        <li>
                            <div>目录管理</div>
                            <div class="row2">鼠标拖动即时调整</div>
                            <div>目录层级无限制</div>
                            <div>批量导出目录</div>
                            <div>批量导入目录</div>
                        </li>
                        <!-- <li>
                            <div>允许完全自定义，增删查改</div>
                            <div>鼠标拖动即可调整目录位置、上下级层次</div>
                            <div>题目随目录的调整相应自动调整</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 6" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li style="line-height: 155px">题型</li>
                        <li>
                            <div>支持单选、多选、判断、填空等所有基本题型</div>
                            <div>选择题选项数可调（支持3~8个选项）</div>
                            <div>选择题支持单独调整某个题目的选项数</div>
                            <div>支持自定义题型</div>
                            <div>完全支持复合题</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                        </li> -->
                        <li>
                            <ul v-for="item in 5" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>
                            <div>难度</div>
                            <div>适用范围</div>
                            <div>题类标签</div>
                        </li>
                        <li></li>
                        <!-- <li>
                            <div>完全允许自定义,可以增删查改</div>
                            <div>完全允许自定义,可以增删查改</div>
                            <div>完全允许自定义,可以增删查改</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>题目录入</li>
                        <li>
                            <div>全兼容Word</div>
                            <div>支持图形、图片、表格</div>
                            <div>支持MathType公式编辑器</div>
                            <div>单题录入</div>
                            <div>批量上传</div>
                            <div>Word全兼容（推荐）</div>
                            <div>模板1</div>
                            <div>模板2</div>
                            <div>模板3</div>
                            <div>重题检查</div>
                            <div>批量入库</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>1、自动识别题型、题目、答案、解析、适用范围、来源、分值等</div>
                            <div>2、一键智能处理：多个功能一键处理，省时省力（熟练用户强烈推荐！）</div>
                            <div>特别适合专业人士、出版社编辑、专业录题编辑</div>
                            <div>确保公式、图形等入库后再次生成试卷时仍然原样可以编辑</div>
                            <div>软件中嵌入Word，直接使用Word添加、编辑题目</div>
                            <div>
                                1、多个上传模板，几乎适应目前所有试卷样式<br>
                                2、提供大量快速批量处理工具<br>
                                3、熟练用户最快1小时可以上传2000~3000题
                            </div>
                            <div>重题检查，显示每个题目的疑似重题，易于筛查</div>
                            <div>自动检查试卷是否符合入库标准，提示准确，入库快速，入库内容自动分类</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 11" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>试题管理</li>
                        <li>
                            <div>题目属性标记于每一题上方</div>
                            <div>编辑和修改题目内容</div>
                            <div>删除</div>
                            <div>审核控制</div>
                            <div>批量修改属性</div>
                            <div>拖动题目更改目录</div>
                            <div>收藏</div>
                            <div>纠错</div>
                            <div>全局共享</div>
                            <div>机构私有</div>
                            <div>用户私有</div>
                        </li>
                        <!-- <li>
                            <div>显示题目所属章节、知识点、题型、难度等</div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>批量快速调整章节、知识点、题型、难度、来源、分值等</div>
                            <div>支持批量拖动题目即可以修改目录所属章节、知识点</div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>可选，机构或者用户自行设定</div>
                            <div>机构用户可自行设定</div>
                            <div>用户可以自行设定</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 11" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>试题检索</li>
                        <li>
                            <div>快速搜索</div>
                            <div>快速筛选</div>
                            <div>快速排序</div>
                        </li>
                        <!-- <li>
                            <div>章节、知识点、题目内容、使用时间、使用次数、来源、回收站、……，任意组合条件搜索</div>
                            <div>章节、知识点、题型、难度、有无答案、有无解析、收藏夹、……，任意组合条件筛选</div>
                            <div>题型、难度、组卷次数、题目内容、……，任意组合条件排序</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>手工组卷</li>
                        <li>
                            <div>查看题目解析</div>
                            <div>试题篮管理</div>
                            <div>重题检查</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>显示相似题内容，快速准确判定是否为重题</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li style="line-height:124px">智能组卷</li>
                        <li>
                            <div>全新选题</div>
                            <div>追加选题</div>
                            <div>组卷方案</div>
                        </li>
                        <!-- <li>
                            <div>新出一份试卷</div>
                            <div>在原有内容基础上追加题目</div>
                            <div>把选题条件保存为组卷方案，后续随时调用生成新试卷</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li style="line-height: 186px">试卷预览</li>
                        <li>
                            <div>调整题目位置</div>
                            <div>换一题</div>
                            <div>分数设置</div>
                            <div>试卷样式设置</div>
                            <div>保存试卷</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>自定义试卷样式</div>
                            <div>自定义卷头：标题、密封线、誊分栏等</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 5" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>试卷库</li>
                        <li>
                            <div>试卷管理</div>
                            <div>查看试卷内容</div>
                            <div>发布考试</div>
                            <div>生成试卷（Word格式）</div>
                            <div>生成PPT</div>
                        </li>
                        <!-- <li>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div class="kong"></div>
                            <div>1、速度快、自动排版</div>
                            <div>2、选择题选项、括号自动对齐</div>
                            <div>3、多种内置试卷样式快速切换</div>
                            <div>4、教师卷、普通卷、学生卷任选</div>
                            <div>5、选择题答案以表格方式展示（可选）</div>
                            <div>6、多个内置版式一键切换</div>
                            <div>生成PPT幻灯片，默认切换效果</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 5" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li>在线考试</li>
                        <li>
                            <div>单机版在线考试</div>
                            <div>logo和形象页定制</div>
                            <div>特殊定制需求</div>
                        </li>
                        <!-- <li>
                            <div>不限制使用的电脑，用于模拟测试</div>
                            <div>一次性购买100套以上</div>
                            <div>付费定制</div>
                        </li> -->
                        <li>
                            <ul v-for="item in 3" :key="item">
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common" id="personal-shouhou">
                        <li>售后服务</li>
                        <li>电话、QQ咨询</li>
                        <!-- <li></li> -->
                        <li>
                            <ul>
                                <li><i class="el-icon-success"></i></li>
                                <li><i class="el-icon-success"></i></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="common">
                        <li style="text-align:left;text-indent:10px">
                            <div>说明：</div>
                            <div ><i class="el-icon-success"></i> 表示支持</div>
                            <div ><i class="el-icon-error"></i> 表示不支持</div>
                        </li>
                        <li></li>
                        <li></li>
                    </ul>

                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            turnIndex: 0,
            path: process.env.BASE_URL,
            zy: require('@/assets/img_zy.png'),
            img_syjc: require('@/assets/p_syjc.png'),
            img_grgm: require('@/assets/p_grgm.png'),
            img_tdgm: require('@/assets/p_tdgm.png'),
            img_kjfp: require('@/assets/p_kjfp.png'),
            icon_tishi: require('@/assets/icon_tishi.png'),
            icon_xiazai: require('@/assets/icon_xiazai.png'),
            newShow: false,
            cloudShow: false,
            personalShow: false,
            show: false,
            curIndex: -1,
            list: [
                {
                    id: 'cooperation',
                    label: '多人协作'
                },
                {
                    id: 'wrong',
                    label: '错题集'
                },
                {
                    id: 'handout',
                    label: '讲义、备课'
                },
                {
                    id: 'catalog',
                    label: '知识库目录'
                },
                {
                    id: 'type',
                    label: '题型'
                },
                {
                    id: 'difficulty',
                    label: '难度'
                },
                {
                    id: 'scope',
                    label: '适用范围'
                },
                {
                    id: 'label',
                    label: '题类标签'
                },
                {
                    id: 'entry',
                    label: '题目录入'
                },
                {
                    id: 'management',
                    label: '试题管理'
                },
                {
                    id: 'retrieval',
                    label: '试题检索'
                },
                {
                    id: 'manual',
                    label: '手工组卷'
                },
                {
                    id: 'intelligent',
                    label: '智能组卷'
                },
                {
                    id: 'preview',
                    label: '试卷预览'
                },
                {
                    id: 'library',
                    label: '试卷库'
                },
                {
                    id: 'department',
                    label: '部门管理'
                },
                {
                    id: 'subject',
                    label: '学科'
                },
                {
                    id: 'teaching',
                    label: '教材'
                },
                {
                    id: 'version',
                    label: '教材版本'
                },
                {
                    id: 'section',
                    label: '学段'
                },
                {
                    id: 'grade',
                    label: '年级'
                },
                {
                    id: 'personnel',
                    label: '人员管理'
                },
                {
                    id: 'role',
                    label: '角色与权限管理'
                },
                {
                    id: 'online',
                    label: '在线考试'
                },
                {
                    id: 'special',
                    label: '特色服务'
                },
                {
                    id: 'after',
                    label: '售后服务'
                },
            ]
        }
    },
    mounted(){
        window.addEventListener('scroll',this.scrollFn);
    },
    methods: {
        toExam(){
            window.open(IPConfig.testExam);
        },
        toWeb(){
            window.open(IPConfig.testTiku);
        },
        scrollFn(){
            let list = document.getElementById('duibi-list').getBoundingClientRect();
            let after = document.getElementById('after').getBoundingClientRect();
            if(list.top < 10 && after.top > 0){
                this.show = true;
            }else{
                this.show = false;
            }

            let net = document.getElementById('net-header').getBoundingClientRect();
            let netS = document.getElementById('net-shouhou').getBoundingClientRect();
            if(net.top <= 0 && netS.top > 0){
                this.newShow = true;
            }else{
                this.newShow = false;
            }

            let p = document.getElementById('personal-header').getBoundingClientRect();
            let pS = document.getElementById('personal-shouhou').getBoundingClientRect();
            if(p.top <= 0 && pS.top > 0){
                this.personalShow = true;
            }else{
                this.personalShow = false;
            }

            let cloud = document.getElementById('cloud-header').getBoundingClientRect();
            let cloudS = document.getElementById('cloud-shouhou').getBoundingClientRect();
            if(cloud.top <= 0 && cloudS.top > 0){
                this.cloudShow = true;
            }else{
                this.cloudShow = false;
            }
        },
        toLook(id){
            document.getElementById(id).scrollIntoView({
                behavior: 'smooth'
            })
        },
        toPosition(id,index){
            this.curIndex = index;
            var y = document.getElementById(id).offsetTop;
            window.scrollTo(0,y - 220);
        },
        turn(index,id){
            this.turnIndex = index;
            // if(id === 'duibi'){
            //     this.$nextTick(() => {
            //         document.getElementById(id).scrollIntoView({
            //             behavior: 'smooth'
            //         })
            //     })
            // }
        }
    },
    destroyed(){
        window.removeEventListener('scroll',this.scrollFn);
    }
}
</script>
<style lang="less">
    .price{
        background-color: #F9FBFE;
        padding-bottom: 100px;
        color: #747474;
        font-size: 14px;
        .el-icon-success{
            color: #409eff;
        }
        .duibi-list{
            display: flex;
            flex-wrap: wrap;
            color: #313131;
            margin-bottom: 30px;
            li{
                cursor: pointer;
                padding: 0 12px;
                border-radius:4px;
                margin-bottom: 10px;
                line-height: 30px;
                &:hover{
                    background-color: #41ADF5;
                    color: #fff;
                }
            }
            li.active{
                background-color: #41ADF5;
                color: #fff;
            }
        }
        .fixed-list{
            position: fixed;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            background-color: #fff;
            border-bottom: 1px solid #dcdcdc;
            padding-top: 20px;
            padding-bottom: 10px;
            display: none;
            .duibi-list{
                width: 1200px;
                margin: 0 auto;
            }
        }
        .fixed-list-block{
            display: block;
        }
        .banner{
            height: 730px;
            background: #198AF7 url('../assets/img_zxjc@2x.png') no-repeat center top;
            background-size: auto 100%;
            .banner-content{
                width: 1200px;
                position: relative;
                margin: 0 auto;
                .left{
                    position: absolute;
                    top: 230px;
                    left: 0;
                    color: #fff;
                    >div{
                        font-size: 20px;
                        margin-bottom: 10px;
                        &:nth-of-type(1){
                            font-size: 36px;
                        }
                    }
                }
            }
        }
        .wrapper{
            width: 1200px;
            margin: 0 auto;
            padding-top: 100px;
            .product-add{
                display: flex;
                margin-top: -230px;
                margin-bottom: 58px;
                img{
                    flex: 1;
                    width: 100px;
                }
            }
            .turn{
                margin: 0 auto;
                display: flex;
                text-align: center;
                .one,.two,.three,.four{
                    border: 1px solid #EBEEF5;
                    background-color: #fff;
                    line-height: 44px;
                    cursor: pointer;
                    font-size: 14px;
                    position: relative;
                    outline: none;
                    margin-right: 34px;
                    border-radius: 22px;
                    width: 138px;
                    box-sizing: border-box;
                    &:hover{
                        background-color: #F88927;
                        color: #fff;
                    }
                    // >span{
                    //     display: inline-block;
                    //     vertical-align: middle;
                    //     &:nth-of-type(1){
                    //         background-color: #C9C9C9;
                    //         color: #fff;
                    //         width: 38px;
                    //         height: 38px;
                    //         line-height: 38px;
                    //         margin-right: 20px;
                    //         border-radius: 50%;
                    //     }
                    //     &:nth-of-type(2){
                    //         color: #313131;
                    //     }
                    // }
                    .line{
                        background: transparent;
                        position: relative;
                    }
                }
                // .one:after,.two:after,.three::after{
                //     content: '';
                //     position: absolute;
                //     right: 0;
                //     top: 50%;
                //     transform: translateY(-50%);
                //     width: 2px;
                //     height: 60px;
                //     background-color: #dcdcdc;
                // }
                .active{
                    background-color: #F88927;
                    >span{
                        color: #fff;
                    }
                    .line{
                        position: relative;
                        &::before{
                            display: inline-block;
                            position: absolute;
                            top: -4px;
                            left: 50%;
                            transform: translateX(-50%);
                            content: '';
                            clear: both;
                            height: 0px;
                            border: 8px solid transparent;
                            border-top-color: #F88927;
                        }
                    }
                }
                
            }
            .title{
                text-align: center;
                color: #F78927;
                font-size: 30px;
                margin-bottom: 40px;
            }
            
            .el-button--primary{
                background-color: #409EFF;
                &:hover{
                    opacity: 0.8;
                }
            }
            .top{
                text-align: center;
                img{
                    width: 100%;
                }
            }
            .intro{
                width: 800px;
                margin: 0 auto;
                margin-top: 20px;
                box-sizing: border-box;
                border-left: 5px solid #2F9EF7;
                color: #454545;
                background-color: #fff;
                box-shadow:0px 0px 7px 0px rgba(0,112,207,0.32);
                border-radius:4px;
                padding: 30px 50px;
                >div{
                    font-size: 18px;
                    margin-bottom: 10px;
                    span{
                        color: #42AEF6;
                    }
                }
            }
            .common{
                display: flex;
                text-align: center;
                justify-content: space-around;
                >li{
                    flex: 1;
                    // padding: 10px 0;
                    line-height: 50px;
                    border-right: 1px solid #EBEEF5;
                    &:nth-last-child(1){
                        flex: 1.8;
                        border-right: none;
                    }
                    &:nth-of-type(1){
                        flex: 0.5;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        >div{
                            width: 100%;
                            border-bottom: 1px solid #EBEEF5;
                            &:nth-last-of-type(1){
                                border-bottom: none;
                            }
                        }
                    }
                    &:nth-of-type(2){
                        div{
                            border-bottom: 1px solid #EBEEF5;
                            &:nth-last-of-type(1){
                                border-bottom: none;
                            }
                        }
                    }
                    ul{
                        display: flex;
                        border-bottom: 1px solid #EBEEF5;
                        &:nth-last-of-type(1){
                            border-bottom: none;
                        }
                        li{
                            flex: 1;
                            padding: 0 20px;
                            line-height: 50px;
                            border-right: 1px solid #EBEEF5;
                            &:nth-last-of-type(1){
                                border: none;
                            }
                        }
                    }
                    // &:nth-of-type(3){
                    //     text-align: left;
                    // }
                    >div.row2{
                        line-height: 101px!important;
                        height: 101px!important;
                    }
                    >div.row3{
                        line-height: 152px!important;
                        height: 152px!important;
                    }
                    >div.row4{
                        line-height: 201px!important;
                        height: 201px!important;
                    }
                    >div.row7{
                        line-height: 356px!important;
                        height: 356px!important;
                    }
                }
            }
            .personal{
                .common{
                    >li{
                        &:nth-last-child(1){
                            flex: 1;
                        }
                    }
                }
            }
            .personal-header,.cloud-header,.net-header{
                position: fixed;
                top: 0;
                left: 0;
                background-color: #fff;
                border-bottom: 1px solid #dcdcdc;
                box-shadow: 0 2px 5px 0 rgba(58,62,81,0.10);
                width: 100%;
                display: none;
                .common{
                    width: 1200px;
                    margin: 0 auto;
                }
            }
            .header-fixed{
                display: block;
            }
            .same{
                .title{
                    margin-top: 40px;
                    text-align: center;
                    color: #656565;
                    font-size: 24px;
                    margin-bottom: 16px;
                }
                .download{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 30px;
                    margin-top: 16px;
                    img{
                        margin-right: 5px;
                        &:nth-of-type(1){
                            margin-left: 20px;
                        }
                    }
                    span{
                        cursor: pointer;
                        color: #45CD84;
                        margin-right: 32px;
                    }
                    a{
                        text-decoration: none;
                        color: #45CD84;
                    }
                    .wx_code{
                        cursor: pointer;
                        color: #45CD84;
                        display: flex;
                        position: relative;
                        >span{
                            display: none;
                            width: 100px;
                            height: 100px;
                            position: absolute;
                            background: url('../assets/weixin.jpg') no-repeat center center;
                            background-size: 100px 100px;
                            left: 80px;
                            top: -40px;
                        }
                        &:hover{
                            span{
                                display: block;
                            }
                        }
                    }
                }
                .update{
                    display: flex;
                    color: #F84B44;
                    justify-content: center;
                    align-items: center;
                    img{
                        width: 14px;
                        height: 14px;
                        margin-right: 5px;
                    }
                    >div{
                        margin-right: 16px;
                    }
                }
                .list{
                    // box-shadow:0px 0px 18px 0px rgba(108,184,255,0.4);
                    border: 1px solid #EBEEF5;
                    background-color: white;
                    .common{
                        // padding: 10px 0;
                        &:nth-of-type(2n){
                            // background-color: #F0F0F0;
                            border-top: 1px solid #EBEEF5;
                            border-bottom: 1px solid #EBEEF5;
                        }
                        &:nth-of-type(1){
                            li{
                                &:nth-of-type(3){
                                    text-align: center;
                                }
                            }
                        }
                        div{
                            line-height: 50px;
                            // height: 50px;
                        }
                        div.kong{
                            line-height: 50px;
                            height: 50px;
                        }
                        .el-icon-check{
                            font-size: 30px;
                            color: blue;
                        }
                        .el-icon-error{
                            // font-size: 30px;
                            color: red;
                        }
                    }
                }
            }
            .duibi{
                .list{
                    .duibiheader-fixed{
                        position: fixed;
                        top: 110px;
                        left: 0;
                        background-color: #fff;
                        border-bottom: 1px solid #dcdcdc;
                        box-shadow: 0 2px 5px 0 rgba(58,62,81,0.10);
                        width: 100%;
                        display: none;
                        .common{
                            width: 1200px;
                            margin: 0 auto;
                        }
                    }
                    .duibiheader-block{
                        display: block;
                    }
                }
            }
        }
    }
</style>